import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { createRedaction, updateRedaction, getRedactionOptions } from '../../lib/apiClient';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';
import AlertMessage from '../Common/Alert';

const RedactionConfiguration = observer((props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);
    const patternRef = useRef(null);
    const typeRef = useRef(null);    
    const [validated, setValidated] = useState(false);
    const [validScopes, setValidScopes] = useState([]);
    const [validTypes, setValidTypes] = useState([]);
    const [, setFormLoaded] = useState(false);
    const [formData, setFormData] = useState({
        buckets: ["*"],
        pattern: '',
        description: '',
        redactAt: 'client',
        environments: ["*"],
        scopes: ["*"],
        type: '',
        level: 'full',
        applyTo: 'key',
        enabled : true
      });

    useEffect(() => {
        loadRedactionOptions();
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        formRef.current?.reset();
        setIsSubmitting(false);

        if(props.redaction){
            // setup the defaults...
            const defaults = {
                buckets: props.redaction?.buckets || ["*"],
                pattern: props.redaction.pattern,
                description: props.redaction.description,
                redactAt: props.redaction.redactAt,
                environments: props.redaction.environments.length ? props.redaction.environments : ["*"],
                scopes: props.redaction.scopes.length ? props.redaction.scopes : ["*"],
                type : props.redaction?.type || 'custom',
                level : props.redaction?.level || 'full',
                applyTo : props.redaction?.applyTo || 'key',
                enabled : props.redaction?.enabled,
            }
            
            typeRef.current.value = defaults.type;
            setFormData(defaults);
        }
    // eslint-disable-next-line
    }, [props.redaction]);

    const handleEnvironmentsChange = (event) => {
        const { value, checked } = event.target;

        let newArray = [];

        if(value === "*" && checked){
            newArray.push("*");
            setFormData({...formData, environments: newArray});
        }else if(value !== "*" && checked){
            newArray = formData.environments;
            newArray.push(value);
            setFormData({...formData, environments: newArray});
        }else if(!checked){
            let newArr = formData.environments.filter(scope => scope !== value);
            if(value !== '*' && newArr.length === 0){
                newArr.push("*");
            }
            setFormData({...formData, environments: newArr});
        }
      };
    const handleBucketChange = (event) => {
        const { value, checked } = event.target;

        let newArray = [];

        if(value === "*" && checked){
            newArray.push("*");
            setFormData({...formData, buckets: newArray});
        }else if(value !== "*" && checked){
            newArray = formData.buckets;
            newArray.push(value);
            setFormData({...formData, buckets: newArray});
        }else if(!checked){
            let newArr = formData.buckets.filter(scope => scope !== value);
            if(value !== '*' && newArr.length === 0){
                newArr.push("*");
            }
            setFormData({...formData, buckets: newArr});
        }
    };

      
    
    const handleTypeChange = (event) => {
        const { value } = event.target;
        setFormData({...formData, type: value});
    };

    const handleApplyToChange = (event) => {
        const { value } = event.target;
        setFormData({...formData, applyTo: value});
    };   

    const handleLevelChange = (event) => {
        const { value } = event.target;
        setFormData({...formData, level: value});
    };       

    const handleScopesChange = (event) => {
        const { value, checked } = event.target;

        let newArray = [];

        if(value === "*" && checked){
            newArray.push("*");
            setFormData({...formData, scopes: newArray});
        }else if(value !== "*" && checked){
            newArray = formData.scopes;
            newArray.push(value);
            setFormData({...formData, scopes: newArray});
        }else if(!checked){
            let newArr = formData.scopes.filter(scope => scope !== value);
            if(value !== '*' && newArr.length === 0){
                newArr.push("*");
            }
            setFormData({...formData, scopes: newArr});
        }
    };

    const loadRedactionOptions = async ()  => {
        let response = await getRedactionOptions();
    
        if(response.successful){
            setValidScopes(response.data.scopes);

            const types = response.data.redactions;
            // now add custom...
            types.push({id: "custom", name: "Custom"});

            setValidTypes(types);
            
            setFormLoaded(true);

        }else{
            
            // TODO: add some error handling.

        }
      };

    const handleSubmit = async (event)  => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
          setIsSubmitting(false);
        }
        
        setValidated(true);
        

        event.preventDefault();
        event.stopPropagation();
    
        // make sure some of this data is clean..
        if(formData.type !== 'custom'){
            formData.pattern = "";
            formData.applyTo = "";
        }
        
        const params = {
          accountSid: props.store.SessionStore.getAccountSid(),
          redactionSid: props.redaction?.sid || null,
          buckets: formData.buckets,
          pattern: patternRef?.current?.value,
          description: formData.description,
          redactAt: formData.redactAt || "client",
          environments: formData.environments,
          scopes: formData.scopes,
          enabled: formData.enabled,
          type: formData.type,
          level: formData.level,
          applyTo: formData.applyTo
        }
        
        setIsSubmitting(true);

        let response;
        if(!params.redactionSid){
            response = await createRedaction(params);
        }else{
            response = await updateRedaction(params);
        }
        
    
        if(response.successful){
            if(props.onComplete){
                props.onComplete(response.data);
            }            
            handleClose();
        }else{
            setIsSubmitting(false);
        }
      };

    const handleClose = () => {
      //console.log(errors);
      formRef.current?.reset();
      props.close();
      setIsSubmitting(false);
    };

    const renderButtons = ()=>{
        return(
            <>
                <Button variant="secondary" onClick={handleClose} className="me-2">
                    Cancel
                </Button>

                {!isSubmitting ? (
                    <Button variant="primary" type="submit">
                        {props.redaction ? ('Update') : ('Create')}
                    </Button>
                    ) : (
                    <Button variant="primary" type="submit" disabled>
                        <span className="spinner-border me-2" role="status" aria-hidden="true"></span> {props.redaction ? ('Updating') : ('Creating')}...
                    </Button>
                )}
            </>
        );
    }
   
  return (
    <>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
            <Row>
                <Col xs={12} md={4}>
                    <h3>{!props.redaction?.sid ? (<>Create</>):(<>Edit</>)} Redaction</h3>
                </Col>
                <Col xs={12} md={8} className="d-flex justify-content-end">
                    <Form.Group className="d-flex align-items-center">
                        <Form.Check // prettier-ignore
                                type="switch"
                                id="enabled"
                                value="*"
                                defaultChecked={formData.enabled}
                                label="Enabled"
                                onChange={(event)=>{setFormData({...formData, enabled: event.target.checked})}} />
                    </Form.Group>
                </Col>
            </Row>
        


            <hr/>
            <h4 className="my-6">Select Location</h4>
            <div className="row mb-3">
                <div className="col-md mb-md-0 mb-4">
                <div className={`form-check custom-option custom-option-icon ${formData.redactAt === "client" ? 'checked' : ''}`}>
                    <label className="form-check-label custom-option-content" htmlFor="client">
                        <span className="custom-option-body">
                            <i className="ti ti-code me-2 ti-lg"></i>
                            <span className="custom-option-title">Redact at API</span>
                            <small>Redacts on your API prior to sending to ApiTraffic servers.<br/>Redacted data will not be available to use in any workflows.</small>
                        </span>
                        <input name="redactAt" className="form-check-input" type="radio" value="client" id="client" defaultChecked={formData.redactAt === "client"} onClick={()=>{setFormData({...formData, redactAt: "client"});}}/>
                    </label>
                </div>
                </div>
                <div className="col-md mb-md-0 mb-4">
                <div className={`form-check custom-option custom-option-icon ${formData.redactAt === "server" ? 'checked' : ''}`}>
                    <label className="form-check-label custom-option-content" htmlFor="server">
                        <span className="custom-option-body">
                            <i className="ti ti-server me-2 ti-lg"></i>
                            <span className="custom-option-title"> Redact at server </span>
                            <small>Allow data to come to ApiTraffic, but redact before saving.<br/>Redacted data can be used in workflows as it will be redacted upon final save.</small>
                        </span>
                        <input name="redactAt" className="form-check-input" type="radio" value="server" id="server" defaultChecked={formData.redactAt === "server"} onClick={()=>{setFormData({...formData, redactAt: "server"});}} />
                    </label>
                </div>
                </div>
            </div>
            <hr/>
            
            <h4 className="my-6">Redaction Configuration</h4>
            <Form.Group className="mb-3" controlId="type">
                <Form.Label>Type*</Form.Label>
                <Form.Select name="type" aria-label="type" value={formData.type} onChange={handleTypeChange} ref={typeRef}>
                    <option value=""></option>
                    {validTypes.map((type) => (
                        <option value={type.id} key={`type_${type.id}`}>{type.name}</option>
                    ))}
                </Form.Select>
                <Form.Text className="text-muted">
                    Select a predefined data type or choose custom to use regex to define the data selection.
                </Form.Text>
            </Form.Group>

            {formData.type === 'custom' &&
                <>
                    <Form.Group className="mb-3" controlId="applyTo">
                        <Form.Label>Apply To*</Form.Label>
                        <Form.Check name="applyTo" type="radio" id="default-key" value="key" label="Key/Property" defaultChecked={formData.applyTo === 'key'} onChange={handleApplyToChange} />
                        <Form.Text className="text-muted ms-4">
                            Applies the redaction to any JSON or XML key/propery and redact that value. 
                        </Form.Text>
                        <Form.Check name="applyTo" type="radio" id="default-value" value="value" label="Value" defaultChecked={formData.applyTo === 'value'} onChange={handleApplyToChange}/>
                        <Form.Text className="text-muted ms-4">
                            Applies the redaction to any value. This includes unstructured data that may be in the payloads.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="pattern">
                        <Form.Label>Pattern*</Form.Label>
                        <Form.Control required type="text" name="pattern" defaultValue={formData.pattern} placeholder="" ref={patternRef} />
                        <Form.Control.Feedback type="invalid">
                            A pattern is required. 
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            Add a pattern for locating the data to redact. 
                        </Form.Text>
                    </Form.Group> 
                </>}

                <Form.Group className="mb-3" controlId="level">
                    <Form.Label>Level*</Form.Label>
                    <Form.Check name="level" type="radio" id="level-full" value="full" label="Full" defaultChecked={formData.level === 'full'} onChange={handleLevelChange} />
                    <div className='ps-4 pb-2'>
                        <Form.Text className="text-muted">
                            Fully redacts the data. For example, the string <code>MySecureString</code> is replaced with <code>[{formData.redactAt === "client" ? 'API REDACTED' : 'SERVER REDACTED'}]</code>. To indicate the data was redacted by {formData.redactAt === "client" ? 'your API before sending to ApiTraffic' : 'the ApiTraffic servers before persisting'}.
                        </Form.Text>
                    </div>
                    <Form.Check name="level" type="radio" id="level-mask" value="mask" label="Mask" defaultChecked={formData.level === 'mask'} onChange={handleLevelChange}/>
                    <div className='ps-4 pb-2'>
                        <Form.Text className="text-muted">
                            Redacts the data by replacing the string with the same number of asterisks as numer of characters in the string. For example, the string <code>MySecureString</code> is replaced with <code>**************</code>.
                        </Form.Text>
                    </div>
                    <Form.Check name="level" type="radio" id="level-partial" value="partial" label="Partial" defaultChecked={formData.level === 'partial'} onChange={handleLevelChange}/>
                    <div className='ps-4'>
                        <Form.Text className="text-muted">
                            Redacts the data by replacing the middle part of the string but keeping the first and last 3 characters. For example, the string <code>MySecureString</code> is replaced with <code>MyS...ing</code>.
                        </Form.Text>
                    </div>
                </Form.Group>


                <div className="row">
                    <div className="col mb-3">
                        <label className="form-label">Scopes*</label>
                    </div>
                </div>
                        
            <div className="row">
                <div className="col mb-3 ms-3">
                    <Form.Check // prettier-ignore
                            type="switch"
                            id="all-scopes"
                            value="*"
                            defaultChecked={formData.scopes.includes("*")}
                            label="Apply to all"
                            onChange={handleScopesChange} />
                </div>
            </div>
            {!formData.scopes.includes("*") ? (
                <div className="row">
                        
                    <div className="col mb-3 ms-3">
                        {validScopes.map((scope) => (    
                            <Form.Check // prettier-ignore
                            type="switch"
                            defaultChecked={formData.scopes.includes(scope.id)}
                            value={scope.id}
                            id={`scope_${scope.id}`}
                            label={scope.name}
                            key={`scope_${scope.id}`}
                            onChange={handleScopesChange}
                        />
                        
                        ))}      
                    </div>
                </div>    
            ) : ('')}

           


            <hr/>
            <h4 className="my-6">Targeting</h4>

            <div className="row">
                <div className="col mb-3">
                    <label className="form-label">Buckets*</label>
                </div>
            </div>

            <div className="row">
                <div className="col mb-3 ms-3">
                    <Form.Check // prettier-ignore
                            type="switch"
                            id="all-buckets"
                            value="*"
                            defaultChecked={formData.buckets.includes("*")}
                            label="Apply to all"
                            onChange={handleBucketChange} />
                </div>
            </div>
                {!formData.buckets.includes("*") ? (
                    <div className="row">
                            
                        <div className="col mb-3 ms-3">
                            {props.store.SessionStore.buckets.map((bucket) => (    
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    defaultChecked={formData.buckets.includes(bucket.sid)}
                                    value={bucket.sid}
                                    id={`bucket_${bucket.sid}`}
                                    label={bucket.name}
                                    key={`bucket_${bucket.sid}`}
                                    onChange={handleBucketChange} />
                            
                            ))}      
                        </div>
                    </div>    
                ) : ('')}
                        

            <div className="row">
                <div className="col mb-3">
                    <label className="form-label">Environments*</label>
                </div>
            </div>

            <div className="row">
                <div className="col mb-3 ms-3">
                    <Form.Check // prettier-ignore
                            type="switch"
                            id="all-environments"
                            value="*"
                            defaultChecked={formData.environments.includes("*")}
                            label="Apply to all"
                            onChange={handleEnvironmentsChange} />
                </div>
            </div>
                {!formData.environments.includes("*") ? (
                    <div className="row">
                            
                        <div className="col mb-3 ms-3">
                            {props.store.SessionStore.environments.map((environment) => (    
                                <Form.Check // prettier-ignore
                                type="switch"
                                defaultChecked={formData.environments.includes(environment.sid)}
                                value={environment.sid}
                                id={`environment_${environment.sid}`}
                                label={environment.name}
                                key={`environment_${environment.sid}`}
                                onChange={handleEnvironmentsChange}
                            />
                            
                            ))}      
                        </div>
                    </div>    
                ) : ('')}
            
            <hr/>

            <h4 className="my-6">General</h4>
            <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control type="text" name="description" defaultValue={formData.description}  placeholder="Name/Description" />
                <Form.Control.Feedback type="invalid">
                    A description is required.
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                    Provide a description for this redaction to make it easier to understand later.
                </Form.Text>
            </Form.Group>

            <hr/>

            {formData.enabled ? (
                <div className="d-flex justify-content-end">
                    {renderButtons()}
                </div>
            ) : (
                <AlertMessage show={!formData.enabled}>
                    <div className="text-center">
                        <div className='mb-3'>This redaction is currently not enabled. It can still be saved but will not be actively redacting data.</div>
                        {renderButtons()}
                    </div>
                </AlertMessage>    
            )}
        </Form>
    </>
  );
});

export default RedactionConfiguration;